import { useEffect, useReducer, useState } from "react";
import { useMap, updateAfterDelete } from "context/mapContext";
import { useLoading, handleLoading } from "context/LoadingContext";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import getEsriDataFromLayer from "context/contextFunctions/getEsriDataFromLayer";
import Dialog from "components/Dialog/Dialog";
import TransferTaskCard from "components/TransferTaskCard";
import performActionOnFeature from "utils/performActionOnFeature";
import checkApplyEditsErrors from "utils/checkApplyEditsErrors";
import { useEsriUrls } from "context/esriUrlsContext";

function JobZoneList() {
  const [map, dispatchMap] = useMap();
  const [, dispatchLoading] = useLoading();
  const [dialogState, dispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const [selectedZoneforDelete, setSelectedZoneforDelete] = useState(null);
  const [esriUrls] = useEsriUrls();
  const {
    view,
    jobZonesLayer,
    jobZonesList,
    graphicsLayer,
    sketchLayer,
    bufferLayer,
    jobZonesGraphicLayer,
  } = map;

  useEffect(() => {
    (async () => {
      handleLoading(dispatchLoading, true);
      try {
        const token = localStorage.getItem("token");
        if (jobZonesLayer && view && token) {
          const orderByFields = ["created_date DESC"];
          const { res: jobZonesRes } = await getEsriDataFromLayer({
            featureLayer: jobZonesLayer,
            orderByFields,
            returnGeometry: true,
            view,
          });

          dispatchMap({
            type: "INIT",
            payload: {
              jobZonesList: jobZonesRes,
            },
          });
        }
      } catch (error) {
        console.log(error);
      }
      handleLoading(dispatchLoading, false);
    })();
  }, [view, jobZonesLayer]);

  const handleNewJobZone = () => {
    dispatchMap({
      type: "INIT",
      payload: {
        polesSelectionComponentMode: "newJobZone",
        polesList: [],
        selectionGeometry: null,
      },
    });
    graphicsLayer?.removeAll();
    sketchLayer?.removeAll();
    bufferLayer?.removeAll();
    jobZonesGraphicLayer?.removeAll();
  };

  const handleJobZoneDetails = (jobZone) => {
    dispatchMap({
      type: "INIT",
      payload: {
        polesSelectionComponentMode: "jobZoneDetails",
        selectedJobZoneforDetails: jobZone,
      },
    });
  };

  const handleDeleteJobZoneDialog = (jobZone) => {
    if (jobZone) setSelectedZoneforDelete(jobZone);
    dispatchDialog({ type: "TOGGLE" });
  };

  const handleCancelDeleteJobZone = () => {
    setSelectedZoneforDelete(null);
    dispatchDialog({ type: "TOGGLE" });
  };

  const handleDeleteJobZone = async () => {
    handleLoading(dispatchLoading, true);
    try {
      const token = localStorage.getItem("token");
      if (view && token) {
        const jobZonesUrl = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_YELLOW_DOOR_SERVICE}/FeatureServer/${esriUrls.Job_Zones}`;
        const jobZoneDeleteNotifications = {
          onSuccessMessage: "Zone Deleted Successfully",
          onErrorMessage: "Error Deleting Zone",
        };

        const jobZoneDeleteRes = await performActionOnFeature({
          url: jobZonesUrl,
          objs: selectedZoneforDelete,
          action: "delete",
          notificationMessages: jobZoneDeleteNotifications,
        });

        const deleteTTHasError = checkApplyEditsErrors(jobZoneDeleteRes);

        if (!deleteTTHasError) {
          updateAfterDelete({
            dispatch: dispatchMap,
            objIdToDelete: selectedZoneforDelete.OBJECTID,
            data: jobZonesList,
            targetName: "jobZonesList",
          });
          dispatchDialog({ type: "TOGGLE" });
        }
      }
    } catch (error) {
      console.log(error);
    }
    handleLoading(dispatchLoading, false);
  };

  return (
    <div className="violation">
      <button
        type="button"
        className="btn btn--primary btn--new_item_btn"
        onClick={handleNewJobZone}
      >
        <img
          src={`${process.env.PUBLIC_URL}/imgs/PlusInCircleIcon.svg`}
          alt="plus"
        />
        New Job Zone
      </button>
      {jobZonesList?.length ? (
        jobZonesList.map((jobZone) => (
          <TransferTaskCard
            toggleDetails={handleJobZoneDetails}
            itemId={jobZone.Zone_Name}
            itemIdText="Zone Name"
            date={jobZone.created_date_ISO}
            item={jobZone}
            key={jobZone.OBJECTID}
            hasDeleteButton
            deleteFunction={handleDeleteJobZoneDialog}
          />
        ))
      ) : (
        <div className="text-center">No Results Found</div>
      )}
      <Dialog
        state={dialogState}
        dispatch={dispatchDialog}
        footer={false}
        title=""
        closeButton
        centered
        className="transferTaskOrderDialog"
      >
        <div>
          <span>Are You Sure You Want To Delete This Job Zone?</span>
          <div
            className="d-flex mt-3"
            style={{ justifyContent: "space-evenly" }}
          >
            <button
              type="button"
              className="btn btn--primary"
              style={{
                "--bg": "#c9252d",
              }}
              onClick={handleDeleteJobZone}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn--primary"
              onClick={handleCancelDeleteJobZone}
            >
              No
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default JobZoneList;
